import clsx from "clsx"
import styles from "./IconButton.module.css"
import { Icon, IconName, IconSize } from "@components/icons/Icon"

export const IconButton = ({
  onClick,
  icon,
  disabled = false,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  icon: IconName
  disabled?: boolean
}) => {
  return (
    <button
      className={clsx(styles.container, disabled && styles.disabled)}
      onClick={(e) => onClick(e)}
      disabled={disabled}
    >
      <Icon name={icon} customColor={"#171717"} size={IconSize.Small} />
    </button>
  )
}
